module.exports = __webpack_public_path__ + "img/lite-room-3.9ed5a997.jpg";